"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MapPin, Phone, ArrowUp, Instagram, Star } from "lucide-react";
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return <footer data-section-id="63504" id="brand-footer" className="dark bg-[#0A0A0A] text-foreground py-16 border-t-[8px] [border-image:linear-gradient(to_right,#E63946,#FFB703,#023E8A,#2A9D8F)_1]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {}
          <div className="lg:col-span-2 space-y-6">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/koi_logo_footer.png" alt="Great Taipei 大台北" className="h-12 w-auto object-contain brightness-110" />
            <p className="font-sans text-muted-foreground max-w-md leading-relaxed text-lg">
              Vibrant, high-energy Taiwanese flavors. From sizzling hotplates to signature claypots, 
              we bring the authentic heart of Taipei's night markets directly to your tray.
            </p>
            <div className="flex items-center gap-8">
              <Link to="#" className="text-[#E63946] hover:text-[#FFB703] transition-colors duration-300" aria-label="Instagram">
                <Instagram className="h-12 w-12" />
              </Link>
              <Link to="#" className="text-[#023E8A] hover:text-[#2A9D8F] transition-colors duration-300" aria-label="Google Reviews">
                <Star className="h-12 w-12" />
              </Link>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-sans text-2xl font-black uppercase tracking-tighter text-[#FFB703]">Navigate</h3>
            <nav className="flex flex-col space-y-3">
              <Link to="/GreatTaipeiPage" className="font-sans font-bold text-muted-foreground hover:text-[#E63946] transition-colors duration-300 w-fit text-lg">
                HOME / 首页
              </Link>
              <Link to="#signatures" className="font-sans font-bold text-muted-foreground hover:text-[#E63946] transition-colors duration-300 w-fit text-lg">
                SIGNATURES / 招牌
              </Link>
              <Link to="#classics" className="font-sans font-bold text-muted-foreground hover:text-[#E63946] transition-colors duration-300 w-fit text-lg">
                CLASSICS / 经典
              </Link>
              <Link to="#sizzling-station" className="font-sans font-bold text-muted-foreground hover:text-[#E63946] transition-colors duration-300 w-fit text-lg">
                SIZZLING / 铁板
              </Link>
            </nav>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-sans text-2xl font-black uppercase tracking-tighter text-[#023E8A]">Find Us</h3>
            <div className="space-y-4 font-sans text-muted-foreground">
              <div className="flex items-start gap-3 bg-white/5 p-4 rounded-xl border border-white/10">
                <MapPin className="h-6 w-6 text-[#2A9D8F] shrink-0 mt-0.5" />
                <span className="leading-tight font-bold">
                  Stall #01-42, Great Taipei Food Court, Central Plaza, Taipei City
                </span>
              </div>
              <div className="flex items-center gap-3 px-4">
                <Phone className="h-5 w-5 text-[#E63946] shrink-0" />
                <span className="font-mono">+886 2 2345 6789</span>
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-white/10 my-10" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="font-sans text-sm font-medium text-muted-foreground text-center md:text-left">
            &copy; {new Date().getFullYear()} GREAT TAIPEI (大台北). AUTHENTIC TAIWANESE CUISINE.
          </p>

          <Button variant="ghost" onClick={scrollToTop} className="group text-foreground hover:text-[#FFB703] hover:bg-transparent gap-2 pl-0 md:pl-4">
            <span className="font-sans font-black uppercase tracking-widest text-xs">Back to Top</span>
            <div className="bg-[#E63946] p-2 rounded-full group-hover:bg-[#FFB703] transition-colors duration-300">
              <ArrowUp className="h-4 w-4 text-white" />
            </div>
          </Button>
        </div>
      </div>
    </footer>;
}